<section aria-label="Results">
  <div class="flex items-center justify-end pb-2">
    <prism-btn
      btnClass="bg-white text-dark-purple font-bold border-2 p-0 m-0 rounded-xl border-dark-purple"
      (click)="downloadReport()"
      [disabled]="!data.length">
      <i class="uil uil-import text-dark-purple font-bold pr-1"></i>
      Download Report
    </prism-btn>
  </div>

  <prism-table
    [columns]="columns"
    [colHeaders]="colHeaders"
    [tableData]="data"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [totalData]="totalData"
    (pageIndexChange)="handlePageIndexChange($event)"
    (pageSizeChange)="handlePageSizeChange($event)"
    (columnDirectionChange)="handleColumnDirectionChange($event)">
    <h2 table-title class="text-dark-purple text-xl font-bold">Results</h2>
  </prism-table>
</section>
